import { useQuery } from 'react-query'
import { AccountApi, ErrorResponse, ForgotPassword } from '@citruscamps/citrus-client'
import { ROUTES } from '../../../../../constants/routes'
import { useRouter } from '../../../../../hooks/useRouter'
import { generateApiConfig } from '../../../../../utils/client-config'
import { useRequestHandler } from '../../../../../hooks/useRequestHandler'

interface IFetchRecoveryCode {
  isValid?: boolean
  isLoading: boolean
  isError: boolean
  error: ErrorResponse | null
  handleResetPassword: (value: ForgotPassword) => Promise<void>
}

export const useFetchRecoveryCode = (): IFetchRecoveryCode => {
  const { requestHandler } = useRequestHandler()
  const router = useRouter()
  const { code } = router.params
  const {
    data: isValid,
    error,
    isError,
    isLoading,
  } = useQuery<boolean, ErrorResponse>(
    'forgot_password',
    async ({ signal }) => {
      if (!code) {
        throw new Error('Unable to fetch data')
      }
      const accountClient = new AccountApi(generateApiConfig())
      await requestHandler(() => accountClient.verifyRecoveryCodeAccount({ id: code }, { signal }))
      return true
    },
    {
      enabled: !!code,
    },
  )

  const handleResetPassword = async ({ password }: ForgotPassword): Promise<any> => {
    try {
      if (!code) {
        throw new Error('Unable to fetch data')
      }
      const accountClient = new AccountApi(generateApiConfig())
      await requestHandler(() =>
        accountClient.resetForgottenPasswordAccount({ id: code, ForgotPassword: { password } }),
      )
      await router.push(ROUTES.DASHBOARD)
    } catch (e: any) {
      throw e
    }
  }

  return {
    isValid,
    error,
    isError,
    isLoading,
    handleResetPassword,
  }
}
